export default {
  landing: [
    {
      "name": "landing",
      "backgroundColor": "#000000",
      "noiseBg": true
    }
  ],
  portfolio: [
    {
      "name": "portfolio",
      "project": "portfolio",
      "projectId": 1,
      "backgroundColor": "#a63533",
      "titleColor": "#E6D47F",
      "descriptionColor": "#FEF8CD",
      "yearColor": "#E6D47F",
      "details": {
        "name": "Portfolio",
        "description": "Easily my toughest, but most valuable project, this portfolio allowed me to tie together my creativity on the front-end with the intricacies of the back-end. I developed this website with the goal of creating something sleek and eye-catching, while showcasing my best work and myself. The result is a beautiful website that I am proud to share with you.",
        "role": "Full Stack",
        "year": "2019",
        "shape": "PSCircle.svg",
        "image": "logo_yellow.svg",
        "subImage": "personal-fire.png",
        "btnColor": "yellow",
        "techList": {
          "frontend": [
            "F0-React.svg",
            "F1-Redux.svg",
            "F2-Redux__Saga.svg",
            "L0-JavaScript.svg",
            "L2-HTML5.svg",
            "L3-Sass.svg",
            "L4-CSS3.svg",
            "F5-GreenSock.svg",
            "F13-three_js.svg"
          ],
          "backend": [
            "L1-CSharp.svg",
            "F3-ASP_NET__Core.png",
            "F4-Entity__Framework__Core.png",
            "T8-Microsoft__SQL__Server.svg"
          ], 
          "tech": [
            "T0-Google__Cloud__Platform.svg",
            "T3-Docker.svg",
            "T4-Kubernetes.svg",
            "T5-NGINX.svg",
            "F8-React__Testing__Library.png",
            "F9-DOM__Testing__Library.png",
            "F6-XUnit.svg",
          ]
        },
        "codeUrl": "https://github.com/mikec-git/React-Portfolio-Site-Public"
      },
      "shapes": [
        {
          "name": "portfolio",
          "id": 0,
          "pos": [
            [-70, -7, -60],
            [-45, 15, -15],
            [-9.5, -3, 7],
            [-3, 10, -1],
            [-4, -8.5, -4],
            [12.5, 5.5, 5],
            [18, -5, 2],
            [60, -15, -50],
          ],
          "scale": [0.4, 0.8, 0.2, 0.2, 0.1, 0.35, 0.35, 0.5],
					"materialId": 0
				}
      ]
    },
    {
      "name": "portfolio",
      "project": "filmbase",
      "projectId": 2,
      "backgroundColor": "#3A0A52",
      "titleColor": "#00FEFF",
      "descriptionColor": "#CEECFD",
      "yearColor": "#00FEFF",
      "details": {
        "name": "Film Base",
        "description": "Film Base delivers content on the latest and greatest movies, TV shows, and actors. Discover up-to-date trailers for popular films and read up on their cast, crew, and reviews. Film Base uses a massive, community built movie and TV database which services millions of people every day. Create an account today to rate and bookmark your favorite films and shows.",
        "role": "Front End",
        "year": "2018",
        "shape": "PSSquare.svg",
        "image": "movie-candy-audience.png",
        "subImage": "movie-coupon.png",
        "btnColor": "blue",
        "techList": {
          "frontend": [
            "F0-React.svg",
            "F1-Redux.svg",
            "F2-Redux__Saga.svg",
            "L0-JavaScript.svg",
            "L2-HTML5.svg",
            "L3-Sass.svg",
            "L4-CSS3.svg"
          ],
          "tech": [
            "T1-Firebase.svg",
            "T13-Illustrator.svg",
            "T14-Photoshop.svg",
            "A0-YouTube__API.svg",
            "A1-The__MovieDB__API.svg",
          ]
        },
        "projectUrl": "https://filmbase.cc/",
        "codeUrl": "https://github.com/mikec-git/FilmBase-React-App"
      },
      "shapes": [
        {
          "name": "portfolio",
          "id": 1,
          "pos": [
            [-35, -20, -35],
            [-30, 8, -1],
            [-15, -5, 5],
            [-8, 10, -1],
            [13, 3, 5],
            [11, -5, 2],
            [15, 16, -18],
            [80, -45, -50],
          ],
          "scale": [0.4, 1, 0.5, 0.7, 0.4, 0.5, 0.5, 0.5],
					"materialId": 1
				}
      ]
    },
    {
      "name": "portfolio",
      "project": "yelpcamp",
      "projectId": 3,
      "backgroundColor": "#290ff0",
      "titleColor": "#F08D0F",
      "descriptionColor": "#FCE5CF",
      "yearColor": "#F08D0F",
      "details": {
        "name": "Yelpcamp",
        "description": "YelpCamp is a crowd-sourced local campground review source. We know how challenging it can be to discover new and unique campsites without trekking through uncharted terrain. YelpCamp eliminates that inconvenience by giving users a platform to share their campground experiences, allowing you to uncover hidden gems right at your fingertips.",
        "role": "Full Stack",
        "year": "2018",
        "shape": "PSX.svg",
        "image": "camping-vw-van.png",
        "subImage": "camping-tree.png",
        "btnColor": "orange",
        "techList": {
          "frontend": [
            "L0-JavaScript.svg",
            "F11-Bootstrap.svg",
            "L2-HTML5.svg",
            "L4-CSS3.svg",
          ],
          "backend": [
            "L5-Node_js.svg",
            "F10-Express_js.svg",
            "F14-Passport_js.svg",
            "T9-MongoDB.svg",
            "T10-Mongoose_js.png",
          ],
          "tech": [
            "A2-Mapbox__API.svg"
          ]
        },
        "codeUrl": "https://github.com/mikec-git/YelpCamp"
      },
      "shapes": [
        {
          "name": "portfolio",
          "id": 2,
          "pos": [
            [-43, 15, -15],
            [-22, -10, 1],
            [-8, 7, -1],
            [0, 20, -20],
            [8, 4.5, 6],
            [12, -9, 2],
            [65, 3, -40],
          ],
          "scale": [0.4, 0.7, 0.3, 0.2, 0.4, 0.4, 0.5],
					"materialId": 2
				}
      ]
    },
    {
      "name": "portfolio",
      "project": "natours",
      "projectId": 4,
      "backgroundColor": "#027002",
      "titleColor": "#FA6BF9",
      "descriptionColor": "#ECD4F7",
      "yearColor": "#FA6BF9",
      "details": {
        "name": "Natours",
        "description": "Natours is your one-stop outdoors trip agency. Have you been waiting to take that getaway trip but never got the chance? With Natours, all of the hard work is taken care of so you can relax and enjoy the full outdoors adventure. Choose from several of our extensive tour packages and experience nature like you have never before.",
        "role": "Front End",
        "year": "2018",
        "shape": "PSTriangle.svg",
        "image": "nature-bird.png",
        "subImage": "nature-flower.png",
        "btnColor": "pink",
        "techList": {
          "frontend": [
            "L2-HTML5.svg",
            "L4-CSS3.svg",
            "L3-Sass.svg"
          ]
        },
        "projectUrl": "https://mikec-git.github.io/Natours/",
        "codeUrl": "https://github.com/mikec-git/Natours"
      },
      "shapes": [
        {
          "name": "portfolio",
          "id": 3,
          "pos": [
            [-40, -7, -15],
            [-16, -10, -1],
            [-15, 4.5, 5],
            [-4, 5, -1],
            [10, -6, 6],
            [20, 18, -14],
            [52, 4, -30],
          ],
          "scale": [0.4, 0.5, 0.5, 0.3, 0.5, 1.2, 0.5],
					"materialId": 3
				}
      ]
    }
  ],
  about: [
    {
      "name": "about",
      "backgroundColor": "#000000",
      "noiseSphere": true
    }
  ]
}